import { createSlice } from '@reduxjs/toolkit'
import { PURGE } from "redux-persist";

const initialState = {
    treeData:[],
    expandedNodes:{},
    sortType:"a-z"
}

export const treeDataSlice = createSlice({
    name: 'treeDataSlice',
    initialState,
    reducers: {
        setTreeDataRed:(state,action)=>{
            state.treeData=action.payload
        },
        setExpandedNodesRed:(state,action)=>{
            state.expandedNodes={...state.expandedNodes,[action.payload]: !state.expandedNodes[action.payload]}
        },
        setSortType:(state,action)=>{
            state.sortType=action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(PURGE, () => initialState); // THIS LINE
    }
})

export const { setTreeDataRed,setExpandedNodesRed,setSortType} = treeDataSlice.actions
export default treeDataSlice.reducer